import { IService } from '@core/interfaces/category';
import { IBusinessBaseInfo, ICustomerBase } from './user';
import { IBookingFormAnswer } from './booking-form';

export interface IAppointment {
  id: number;
  startDate?: string;
  status: AppointmentStatus;
  title: string;
  publicToken: string;
  businessProfileId: number;
  cancellationReason?: string;
  customerId: number;
  endDate: string;
  services: IService[];
  guest?: IGuest,
  teamMemberColor: string;
  teamMemberProfileName?: string;
  teamMemberProfileId?: number;
  businessToolId?: number;
  businessToolName?: string;
  calendarBlockType?: CalendarAvailabilityBlockType;
  customFields?: IBookingFormAnswer[];
  // for fullcalendar
  end?: string;
  start?: string;
  bookingId?: number;
  startEditable?: boolean;
}

export interface IGuest {
  email: string;
  fullName: string;
  phoneNumber: string;
  id: number;
}

export interface ICustomerAppointment extends IAppointment {
  businessProfile: IBusinessBaseInfo
}

export interface IBusinessAppointment extends IAppointment {
  customerProfile?: ICustomerBase,
}

export interface IAssignTeamMemberRequest {
  appointmentId: number;
  teamMemberProfileId: number;
  forceAssign?: boolean;
}

export interface IAssignTeamMemberResponse {
  hasConflict: boolean;
  conflictMessage?: string;
  appointment?: IBusinessAppointment;
}


export interface INewAppointmentDateInput {
  start: Date,
  end: Date | number
}


export enum AppointmentStatus {
  Unknown = "Unknown",
  Pending = "Pending",
  Confirmed = "Confirmed",
  Canceled = "Canceled",
  Declined = "Declined"
}

export enum CalendarAvailabilityBlockType {
  Availability = "Availability",
  Unavailability = "Unavailability"
}

export interface ICalendarAvailabilityBlock {
  id: number;
  businessProfileId: number;
  teamMemberProfileId?: number;
  teamMemberProfileName?: string;
  teamMemberColor?: string;
  startDate: string;
  endDate: string;
  type: CalendarAvailabilityBlockType;
  notes?: string;
}

